import styled from "styled-components";

import { Text } from "@ui/Atoms";
import { transition } from "@ui/helpers";

export const AnchorOverlay = styled.a`
  position: absolute;
  z-index: 1;
  inset: 0;
  opacity: 0;
`;

export const OpacityOverlay = styled.div`
  position: absolute;
  z-index: 1;
  inset: 0;
  opacity: 0.4;
  background-color: ${props => props.theme.palette.blue700};
`;

export const ImageWrapper = styled.div`
  border-radius: 12px;
  overflow: hidden;
  position: relative;

  .gatsby-image-wrapper {
    height: 380px;
    transition: ${props =>
      transition("transform", props.theme.animations.durationLong, "ease-out")};

    ${({ theme }) => theme.breakpointsV2.smallTablet} {
      height: 340px;
    }

    ${({ theme }) => theme.breakpointsV2.smallDesktop} {
      height: 440px;
    }
  }
`;

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${({ theme }) => theme.spacing.spacing_16};

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    gap: ${({ theme }) => theme.spacing.spacing_24};
  }

  &:has(${AnchorOverlay}:hover) {
    ${({ theme }) => theme.breakpointsV2.smallTablet} {
      ${ImageWrapper} .gatsby-image-wrapper {
        transform: scale(1.05);
      }
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${props => props.theme.palette.white};
`;

export const Title = styled(Text).attrs({
  as: "h3",
  $style: {
    default: "bold_24",
    smallTablet: "bold_28",
  },
})``;

export const Cta = styled(Text).attrs({
  $style: "medium_16",
})``;

export const Label = styled(Text).attrs({
  as: "span",
  $style: "semibold_14",
  $allUnset: true,
  $color: "white",
})`
  background-color: ${props => props.theme.palette.blue700};
  border-radius: 8px;
  width: fit-content;
  padding: ${props => props.theme.spacing.spacing_2}
    ${props => props.theme.spacing.spacing_8};
  position: absolute;
  top: ${props => props.theme.spacing.spacing_16};
  right: ${props => props.theme.spacing.spacing_16};
  z-index: 1;
`;
